import { lazyRouteComponent } from "@tanstack/react-router";
import { Star } from "lucide-react";

import type { PageDef } from "@/app/registry";

export interface WatchlistSearch {
  /** The open watchlist's id (default: the first). */
  list?: number;
}

export const pages: PageDef[] = [
  {
    path: "/app/watchlist",
    title: "Watchlist",
    component: lazyRouteComponent(() => import("./WatchlistPage"), "WatchlistPage"),
    nav: { label: "Watchlist", icon: Star, group: "Markets", order: 90 },
    validateSearch: (s): WatchlistSearch => {
      const n = typeof s.list === "number" ? s.list : typeof s.list === "string" ? Number(s.list) : NaN;
      return Number.isInteger(n) && n > 0 ? { list: n } : {};
    },
  },
];
